<template>
  <section class="section">
    <div class="container is-widescreen">
      <h4 class="title is-4 is-size-5-mobile has-text-secondary" v-t="'project-resume-title'"></h4>
      <app-capsule-resume :capsule="project" v-for="(project,index) in projects" :key="project._id" :reverse="index === 0 || !!(index && !(index%2))"/>
    </div>
     <AppLibraryButtonSection id="libraryButton"/>
  </section>

</template>

<script>
import AppCapsuleResume from '@/components/AppCapsuleResume'
import AppLibraryButtonSection from '@/components/AppLibraryButtonSection'
export default {
  components: {
    AppCapsuleResume,
    AppLibraryButtonSection
  },
  computed: {
    projects () {
      return this.$store.getters.formattedCapsules.filter(capsule => capsule.featured)
    }
  }
}
</script>

<style scoped>
#libraryButton{
  padding: 4rem;
}
</style>
